import React from 'react';
import PropTypes from 'prop-types';

import './checkbox.scss';

const Checkbox = ({
  checked,
  children,
  className,
  disabled,
  id,
  invalid,
  label,
  onChange,
}) => (
  <label htmlFor={id} className={`checkbox ${invalid ? 'checkbox_error' : ''} ${disabled ? 'checkbox_disabled' : ''} ${className}`}>
    {label && <span className="checkbox__label">{label}</span>}
    <input
      className='checkbox__input'
      type="checkbox"
      id={id}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
    <span className='checkbox__control' onClick={onChange}/>
    {children}
  </label>
);

Checkbox.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  invalid: false,
  label: '',
  onChange: () => {},
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  invalid: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default Checkbox;
